import type { UpdateProfileIdentityResponse } from '@shared/schemas';

import api from '@/shared/api/api-client';

import type { EditProfileIdentityGateway } from './edit-profile-identity.gateway';

/**
 * Real implementation over the shared api client. The single place that knows
 * the endpoints. `api.patch` unwraps the `{ data }` envelope, so this resolves
 * directly to the identity payload.
 */
export const httpEditProfileIdentityGateway: EditProfileIdentityGateway = {
  updateIdentity: (id, input) => api.patch<UpdateProfileIdentityResponse>(`/profiles/${id}`, input),
  updateLicenceName: (id, input) =>
    api.put<UpdateProfileIdentityResponse>(`/profiles/${id}/licence-name`, input),
};
